import ListItem from './ListItem.view';

export default ListItem;
